export class RemoveBoardAction {
  public static readonly type = '[Project/Manager/List] RemoveBoardAction';
  constructor(public readonly id: string) {}
}
